export default class AnswerModel {
    instruction?: string;

    value: string | number = 0;

    constructor(instructionUuid: string) {
        this.instruction = instructionUuid;
    }
}
